// extracted by extract-css-chunks-webpack-plugin
module.exports = {"product-availability-message":"p0SmQ"};